import { string } from 'yup';

export const englishStringRegEx = /^[A-Za-z0-9\s!@#$%^.,%?&*()_+-]*$/;

export const englishString = string().matches(
  englishStringRegEx,
  'English letters only'
);

export const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

export const maxTwoWhiteSpaces = /^[^ ]*(?:\s[^ ]*){0,2}$/;

export const passwordString = string()
  .min(8, 'Password should be 8 characters long')
  .matches(/[A-Z]/, 'Password should contain at least 1 capital letter')
  .matches(/[0-9]/, 'Password should contain at least 1 digit')
  .matches(/[a-z]/, 'Password should contain at least 1 lowercase letter')
  .matches(/[^A-Za-z0-9]/, 'Password should contain at least 1 special symbol');

export const macAddressRegex = /^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/;
export const hexColorRegex = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;

export const isRequired = ' is a required field';

export const urlRegex =
  /^(https?:\/\/)?([\wа-яА-ЯёЁ.+-]+)\.([a-zа-яА-ЯёЁ]{2,})([/\wа-яА-ЯёЁ.+-]*)*(\?[;&\wа-яА-ЯёЁ+=%_.-]*)?(#[\wа-яА-ЯёЁ+-]*)?$/;

export const noCommaRegex = /^[^,]*$/;
export const locationRegex =
  /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)\s*,\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;

const IpOctet = '(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]?|0)';
export const IpRegex = new RegExp(
  `^${IpOctet}\\.${IpOctet}\\.${IpOctet}\\.${IpOctet}$`
);

export const vinValidation = string()
  .required('VIN is required')
  .test('length', 'VIN must be exactly 17 characters', (value) => {
    return value ? value.length === 17 : false;
  })
  .test(
    'invalid-characters',
    'VIN must contain only English letters and numbers',
    (value) => {
      return value ? /^[a-zA-Z0-9]+$/.test(value) : false;
    }
  )
  .test(
    'prohibited-letters',
    'VIN cannot contain the letters I, O, or Q',
    (value) => {
      return value ? !/[IOQioq]/.test(value) : false;
    }
  )
  .test(
    'must-have-letter',
    'VIN must contain at least one English letter',
    (value) => {
      return value ? /[a-zA-Z]/.test(value) : false;
    }
  )
  .test('must-have-digit', 'VIN must contain at least one number', (value) => {
    return value ? /\d/.test(value) : false;
  });
